var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTurnTime = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.359 12.643a10.38 10.38 0 1 1-1.131-5.394M11.5 7v6M11.5 13H17"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 2.5v5h-5"
})));
SvgTurnTime.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgTurnTime);
export default ForwardRef;